import React from 'react';
import PropTypes from 'prop-types';
import {Box, Paper, Text} from '@tenancy.nz/design-system';
import CustomHeading from '../CustomHeading';
import {isObject} from '../../utils/helpers';

const SectionVariants = {
  standard: 'standard',
  outlined: 'outlined',
};

function Section({
  color,
  children,
  heading,
  intro,
  introLabel,
  variant,
  borderColor,
}) {
  const isIntroLabelIcon = isObject(introLabel);
  return (
    <Box margin="20px 0 25px 0">
      <Paper elevate>
        <Box
          padding="15px"
          border={
            variant === SectionVariants.outlined
              ? `3px solid ${borderColor}`
              : '0px solid transparent'
          }
          borderRadius="10px">
          <Box flex={1}>
            {heading && (
              <CustomHeading as="h4" variant="h5" barColor={color}>
                {heading}
              </CustomHeading>
            )}
            <Text as="span" color="inherit">
              {introLabel && (
                <Text as="span" color="secondary" weight="600" display="inline">
                  {isIntroLabelIcon && (
                    <Box
                      as="span"
                      display="inline-block"
                      marginTop="1px"
                      sx={{
                        verticalAlign: 'middle',
                      }}>
                      {introLabel}
                    </Box>
                  )}
                  {!isIntroLabelIcon && introLabel}{' '}
                </Text>
              )}
              {intro}
            </Text>
            <Box marginTop="20px">{children}</Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}

Section.propTypes = {
  /**
   * Sets the action color. E.g. the right bar of heading.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * React component, HTML node, string etc..
   */
  children: PropTypes.node.isRequired,

  /**
   * Heading of the section
   */
  heading: PropTypes.node,

  /**
   * Introduction text of the section
   */
  intro: PropTypes.node,

  /**
   * Highlighted text displayed at start of introduction text
   */
  introLabel: PropTypes.node,
  variant: PropTypes.oneOf(Object.values(SectionVariants)),
  borderColor: PropTypes.string,
};

Section.defaultProps = {
  color: 'primary',
  heading: '',
  intro: '',
  introLabel: '',
  variant: 'standard',
  borderColor: 'transparent',
};

export default Section;
